import React from 'react';
import { Button } from 'antd';
import type { ButtonProps } from 'antd/lib/button';
import { useDebounceFn } from 'ahooks';

export type IWithButtonProps = {
    time?: number; // 按钮防抖的事件（毫秒） 可选参数 默认为200ms
} & ButtonProps;

function WithButton(props: IWithButtonProps) {
    const { time = 200, onClick = () => { return; }, ...OtherProps } = props;
    const { run } = useDebounceFn(onClick, {
        wait: time,
        leading: true,
        trailing: false,
    });
    return <Button {...OtherProps} onClick={run}></Button>;
}
WithButton.Group = Button.Group;
export default WithButton;
